import {connect} from 'react-redux';
import {DesignWeb as Component} from './DesignChapterWeb';
import {
  getNextMenuValue
} from '../NotebookExpDesignWeb/NotebookExpDesignWeb.selector';
import {
  getTitle,
  getViewType,
  getCollapsed,
  getSlideTree,
  getDescription,
  getHintVisibility,
  getIsDesignChapter,
} from './DesignChapterWeb.Selector';
import {
  setDesignTab,
  viewThreeHint,
  viewFourHint,
} from '@learningblocks/exp-redux';

function mapStateToProps(state) {
  return {
    title: getTitle(state),
    viewType: getViewType(state),
    slideTree: getSlideTree(state),
    collapsed: getCollapsed(state),
    description: getDescription(state),
    hintVisibility: getHintVisibility(state),
    isDesignChapter: getIsDesignChapter(state),
    nextMenuValue: getNextMenuValue(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetTab: (params) => {
      dispatch(setDesignTab(params));
    },
    viewThreeHint: () => {
      dispatch(viewThreeHint());
    },
    viewFourHint: () => {
      dispatch(viewFourHint());
    },
  };
}

export const DesignChapterWeb = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
